import React from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useMutation } from 'react-query';
import { contactsAPI } from '../../services/api';

const { TextArea } = Input;

const NoteModal = ({ visible, contact, onCancel, onSuccess }) => {
  const [form] = Form.useForm();

  const addNoteMutation = useMutation(
    (data) => contactsAPI.update(contact.id, {
      notes: (contact.notes || '') + '\n\n' + data.note
    }),
    {
      onSuccess: () => {
        message.success('Note ajoutée avec succès');
        form.resetFields();
        onSuccess();
      },
      onError: (error) => {
        message.error(error.response?.data?.message || 'Erreur lors de l\'ajout de la note');
      }
    }
  );

  const handleSubmit = async (values) => {
    addNoteMutation.mutate(values);
  };

  const isLoading = addNoteMutation.isLoading;

  return (
    <Modal
      title="Ajouter une note"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="note"
          label="Note"
          rules={[{ required: true, message: 'Veuillez saisir une note' }]}
        >
          <TextArea 
            placeholder="Ajouter une note à propos de ce contact..." 
            rows={6}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            Ajouter la note
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default NoteModal;
